export const encodeParams = (
  parameters: Record<string, string | boolean | number>,
  cleanParams = true
): string => {
  const keys = Object.keys(parameters);
  if (keys.length === 0) {
    return "";
  }

  return keys
    .map(
      key =>
        `${key}=${encodeURIComponent(
          cleanParams ? clean(parameters[key]) : parameters[key]
        )}`
    )
    .join("&");
};

const clean = (value: string | boolean | number): string => {
  const valueAsString = typeof value === "string" ? value : value.toString();
  return valueAsString
    .replace(/[+?~'"`()!:;*.,@£${[\]}#¤%&_/=<>|]/g, "")
    .trim();
};
